import {ProductsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {HorizontalSliderProps} from '@aboutyou/ui-components';
import React from 'react';
import {AdditionalTile} from '../../../../backend-services/ArticleDetail/Recommendations/AdditionalTile';
import {ProductTileProps} from '../../../ProductTile/ProductTile';
import {RecommendationsLane} from '../../../Recommendations/RecommendationsLane';

export const ProductsSlider: React.FC<
  ProductsSection &
    HorizontalSliderProps & {
      className?: string;
      streamPosition: number;
      ProductTileComponent?: React.FC<ProductTileProps>;
      onAddToBasketCtaClick?: ({productId}: {productId: number}) => void;
    }
> = ({
  className,
  topline,
  headline,
  products,
  more,
  streamPosition,
  promotionTracker,
  ProductTileComponent,
  onAddToBasketCtaClick,
  ...sliderProps
}) => {
  return (
    <RecommendationsLane
      onAddToBasketCtaClick={onAddToBasketCtaClick}
      uniqueKey={`productsSlider-${streamPosition}`}
      className={className}
      type="list"
      streamPosition={streamPosition}
      topline={topline}
      headline={headline}
      products={products}
      ProductTileComponent={ProductTileComponent}
      promotionTracker={{
        ...promotionTracker,
        promotionName: promotionTracker.locationId ?? '',
      }}
      AdditionalTile={
        more?.type?.$case === 'discover' && (
          <AdditionalTile
            image={more.type.discover.coverImage}
            label={more.type.discover.primaryCta.label}
            href={more.type.discover.primaryCta.linkTarget.url}
          />
        )
      }
      {...sliderProps}
    />
  );
};
